/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import Logo from "../../../assets/images/logo.svg"
import Logo1 from "../../../assets/images/logo1.svg"
import Logo2 from "../../../assets/images/logo2.svg"
import DarkLogo from "../../../assets/images/dark-logo.svg"
import DarkLogo1 from "../../../assets/images/dark-logo1.svg"
import DarkLogo2 from "../../../assets/images/dark-logo2.svg"
import { Link, useNavigate, useParams } from "react-router-dom";
import { languages } from "../../../shared/utils/languages";
import { uiActions } from "../../../shared/store/ui-Slice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const CommonHeader = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { i18n, t } = useTranslation('common');

    useEffect(() => {
        // const headerEl: any = document.getElementById('header');
        // headerEl.style.display = 'none';
        const footerEl: any = document.getElementById('footer');
        if (!!footerEl) footerEl.style.display = 'none'
    }, [])

    useEffect(() => {
        if (!!params?.lang) {
            if (params?.lang === "hi" || params?.lang === "en" || params?.lang === "mr") {
                let obj: any = languages?.find((item: any) => item?.value === params?.lang);

                if (!!obj && Object?.keys(obj)?.length > 0) {
                    i18n.changeLanguage(obj?.value);
                    dispatch(uiActions.changeLang(obj?.value));
                } else {
                    i18n.changeLanguage("en");
                    dispatch(uiActions.changeLang("en"));
                }
            } else {
                navigate("/en")
            }
        } else {
            i18n.changeLanguage("en");
            dispatch(uiActions.changeLang("en"));
        }
    }, [params?.lang])

    return (
        <div className="mms:h-[70px] xlx:h-[90px] dark:border-b dark:border-[rgba(76,143,186,0.20)] shadow-[0px_2px_4px_-2px_rgba(24,39,75,0.12),0px_4px_4px_-2px_rgba(24,39,75,0.08)] flex items-center justify-center w-full bg-white dark:bg-bgDarkDull">
            <div className="py-[4px] mms:py-0 h-full xsm:px-[15px] !px-0 container flex items-center">
                <Link aria-label={t("aria_label.home")} title={t("aria_label.home")} to={`${window?.location?.pathname.includes("/admin") ? (!!params?.lang ? `/${params?.lang}/admin` : "/admin") : ""}`} className={`${window?.location?.pathname.includes("/admin") ? "hover:bg-[#f4f4f4] hover:rounded-[10px] focus:bg-[#f4f4f4] focus:rounded-[10px] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e]" : ""}`}>
                    <img src={lang === "en" ? `${theme === "dark" ? DarkLogo : Logo}` : lang === "hi" ? `${theme === "dark" ? DarkLogo1 : Logo1}` : `${theme === "dark" ? DarkLogo2 : Logo2}`} alt={`${lang === "en" ? "Mumbai Metro Rail Corporation Limited" : lang === "hi" ? "मुंबई मेट्रो रेल कॉर्पोरेशन लिमिटेड" : "मुंबई मेट्रो रेल कॉर्पोरेशन मर्यादित"}`} className='w-[240px] mms:w-[80%] lgl:w-[90%] xlx:w-auto' />
                </Link>
            </div>
        </div>
    );
};

export default CommonHeader;